import { Component } from '@angular/core';
import { StatsWidgetComponent } from './components/stats-widget/stats-widget.component';
import { ProbabilitiesComponent } from './components/probabilities/probabilities.component';

@Component({
  selector: 'app-dash',
  imports: [StatsWidgetComponent, ProbabilitiesComponent],
  templateUrl: './dash.component.html',
  styleUrl: './dash.component.scss'
})
export class DashComponent {

}
